import { z } from "zod";

/**
 * One stretch of the source a cut keeps, in the source's own timeline. What the author draws is
 * the inverse — the stretches to remove — and the client sends what survives, because that is
 * what a renderer takes.
 *
 * The bounds a range has to satisfy against the video it belongs to are checked on the server
 * (`handlers/videos/cut-range.ts`): a schema sees the body and not the row, and the duration is
 * a property of the row.
 */
const cutSegmentSchema = z.object({
	startTime: z.number().min(0),
	endTime: z.number().positive(),
});

export const postVideoCutSchema = z.object({
	segments: z.array(cutSegmentSchema).min(1),
	/**
	 * Whether to keep the full recording after the cut is published. Asked of the author at the
	 * moment they confirm, with both answers as one click: keeping it is what makes the cut
	 * adjustable later, and discarding it is what makes a removal permanent.
	 */
	keepSource: z.boolean(),
});

export type PostVideoCutSchema = z.infer<typeof postVideoCutSchema>;
